import { SidebarService } from './../sidebar.service';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, output } from '@angular/core';
import { IconComponent } from '../../icon/icon.component';
import { icons } from '../../icon/icons';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'SidebarLink',
  standalone: true,
  imports: [CommonModule, IconComponent, RouterModule],
  templateUrl: './link.component.html',
  styleUrl: './link.component.scss',
})
export class SidebarLinkComponent {

  env = environment.mode;

  @Input() label!: string;
  @Input() link!: string;
  @Input() disabled = false;
  @Input() icon!: string;
  @Input() useFontAwsome: boolean = false;


  @Output() clicked: EventEmitter<any> = new EventEmitter();

  classDefault = 'disabled:opacity-40 flex items-center w-full p-2 my-2 text-gray-900 transition duration-75 rounded-lg pl-3 group hover:bg-gray-800 hover:text-white ';

  active = 'bg-blue-900 text-white hover:bg-blue-800';

  ngOnInit(): void {
    this.disabled = (this.env == 'development') ? false : this.disabled;
   }

  closeSidebar(){
    this.clicked.emit();
  }

}
